// generated during release, do not modify

/**
 * The current version, as set in package.json.
 * @type {string}
 */
export const VERSION = '5.43.4';
export const PUBLIC_VERSION = '5';
